export const columns = [
    { field: 'date',                    headerName: 'Fecha',        flex: 1, align: 'center', headerAlign: 'center' },
    { field: 'amount',                  headerName: 'Importe',      flex: 1, align: 'center', headerAlign: 'center', mobileClickable: true },
    { field: 'expenseTypeDescription',  headerName: 'Tipo de gasto',flex: 1, align: 'center', headerAlign: 'center' },
  ];